var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-header'),_c('div',{staticClass:"wrapper"},[(_vm.notAvailableYet)?_c('not-available-yet'):(_vm.maintenanceIsActive)?_c('maintenance'):_c('router-view')],1),_c('the-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }